import { ISelectedItem } from "@zendeskgarden/react-dropdowns";

export const searchOptions = ["ticket", "user", "organization"];

export const searchTagOptionsTicket: ISelectedItem[] = [
    { value: "ID", name: "ticket", type: "radio" },
    { value: "Nome", name: "ticket", type: "radio" },
    { value: "Status", name: "ticket", type: "radio" },
    { value: "Data de criação", name: "ticket", type: "radio" }
];

export const advancedTagOptionsTicket: ISelectedItem[] = [
    { value: "Prioridade", name: "ticket", type: "radio" },
    { value: "Grupo", name: "ticket", type: "radio" },
    { value: "Responsável", name: "ticket", type: "radio" },
    { value: "Canal de entrada", name: "ticket", type: "radio" },
    { value: "Tags", name: "ticket", type: "radio" },
    { value: "Data de atualização", name: "ticket", type: "radio" },
    { value: "Solicitante", name: "ticket", type: "radio" },
    { value: "Marca", name: "ticket", type: "radio" },
    { value: "Tipo", name: "ticket", type: "radio" },
    { value: "Formulário", name: "ticket", type: "radio" },
    // { value: "Origem do caso", name: "ticket", type: "radio" }
];

export const searchTagOptionsUsers: ISelectedItem[] = [
    { value: "Email", name: "user", type: "radio" },
    { value: "Nome", name: "user", type: "radio" },
    { value: "Tag", name: "user", type: "radio" },
    { value: "Data de criação", name: "user", type: "radio" },
    { value: "Fuso horário", name: "user", type: "radio" }
];

export const searchTagOptionsOrganizations: ISelectedItem[] = [
    { value: "Domínio", name: "organization", type: "radio" },
    { value: "Nome", name: "organization", type: "radio" },
    { value: "Tag", name: "organization", type: "radio" },
    { value: "Data de criação", name: "organization", type: "radio" },
    { value: "Última atualização", name: "organization", type: "radio" }
];